import { Box, Column, Typography, type ColumnProps } from '@vp/swan'
import type { AwardCallout } from '../../../types/site-footer'
import { useEffect } from 'react'
import { ComponentType } from '../../../types/components-map'

interface AwardCalloutSectionProps {
  awardCallout: AwardCallout
  spanLength: ColumnProps['span']
}

export const AwardCalloutSection: React.FC<AwardCalloutSectionProps> = ({ awardCallout, spanLength }) => {
  useEffect(() => {
    if (!awardCallout?.script) return

    const script = document.createElement('script')
    script.src = awardCallout.script
    document.body.appendChild(script)

    return () => {
      script.remove()
    }
  }, [awardCallout?.script])

  const trackingAwardCalloutData = JSON.stringify({
    bookendName: ComponentType.FOOTER,
    navigationDetailPath: awardCallout.analyticsId ? [awardCallout.analyticsId] : [],
  })

  return (
    <Column span={spanLength} spanXs={12} spanSm={12} pl={0} mt={{ xs: 7, md: 0 }}>
      {awardCallout.img && (
        <Box marginBottom="4">
          <img src={awardCallout.img.url} alt={awardCallout.altText} loading="lazy" />
        </Box>
      )}
      <Typography fontSkin="footnote" darkMode dangerouslySetInnerHTML={{ __html: awardCallout.html }} data-tracking={trackingAwardCalloutData} />
    </Column>
  )
}
